export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(function scrollTop() {
      var scrollTop = 0;

      $(window).scroll(function(){
        scrollTop = $(window).scrollTop();
        $('.counter').html(scrollTop);

        if (scrollTop >= 50) {
          $('.header > .header-el-wrapper').addClass('scrolled-nav');
          $('.scroll-top').addClass('scrolled-fade');
        } else if (scrollTop < 50) {
          $('.header > .header-el-wrapper').removeClass('scrolled-nav');
          $('.scroll-top').removeClass('scrolled-fade');
        }
      });
    });

    // function playAudio() {
    //   var audio = new Audio('/wp-content/uploads/2020/11/Hanover-Milk-Bottle-Sonic.mp3');
    //   audio.play();
    // }

    // add_filter( 'gform_submit_button', 'add_onclick', 10, 2 );
    // function add_onclick( $button, $form ) {
    //   $dom = new DOMDocument();
    //   $dom->loadHTML( '<?xml encoding="utf-8" ?>' . $button );
    //   $input = $dom->getElementsByTagName( 'input' )->item(0);
    //   $onclick = $input->getAttribute( 'onclick' );
    //   $onclick .= "playAudio();"; // Here's the JS function we're calling on click.
    //   $input->setAttribute( 'onclick', $onclick );
    //   return $dom->saveHtml( $input );
    // }

    // window.onload = function() {
    //   document.getElementById('gform_submit_button_2').onclick = function fun() {
    //     event.preventDefault();
    //     playAudio();
    //
    //   };
    //
    // };

    var nav = $('.nav-primary');

    if (nav.length) {
      jQuery('html, body').animate({
        scrollTop: jQuery(window.location.hash).offset(),
      }, 800);
    }

    $('.scroll-top').click(function(){
      $('html, body').animate({scrollTop : 0},500);
      return false;
    });

    // // Accordion
    // var menu_header = $('.menu-header');
    // var collapse = $('.collapse');
    //
    // // Accordion collapse function
    // $('.menu-header').click(function () {
    //   $(this).parent().find(collapse).slideToggle();
    //   $(menu_header).data('clicked', true);
    //
    //   $(this).parent().siblings().children().next().slideUp();
    // });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js